<script setup lang="ts">
/**
 * VIP and an account's VIP 等级 as a badge, in the style 会员等级 picks
 * for the platform (utils/vipBadge.ts draws it): beside a VIP customer's
 * name in both consoles, and in 会员等级's own preview. The markup is
 * built from the level number alone — nothing a user typed — so v-html is
 * safe here. Shared byte-identical by both consoles.
 */
import { computed } from 'vue'
import { vipBadgeSvg } from '@/utils/vipBadge'

const props = withDefaults(defineProps<{ level: number; variant?: string; scale?: number }>(), { scale: 1 })
// Gradient and mask ids are page-wide: each badge its own.
const prefix = `vipb${Math.random().toString(36).slice(2, 9)}`
const svg = computed(() => vipBadgeSvg(props.variant, props.level, props.scale, prefix))
</script>

<template>
  <span class="vip-badge" :aria-label="`VIP${level}`" role="img" v-html="svg" />
</template>

<style scoped>
.vip-badge {
  display: inline-flex;
  flex: none;
  align-items: center;
  line-height: 0;
}
</style>

<style>
/* The sweep of light across 流光胶囊 and 进阶套系's black card: across,
   then a pause. Not for those who ask the system for less motion. */
@keyframes vipb-sweep {
  0% {
    transform: translateX(0);
  }
  55%,
  100% {
    transform: translateX(110px);
  }
}
.vipb-shine {
  animation: vipb-sweep 3.2s ease-in-out infinite;
}
@media (prefers-reduced-motion: reduce) {
  .vipb-shine {
    animation: none;
    opacity: 0;
  }
}
</style>
